<template>
    <div class="register">
        <!-- <div class="tit">注册</div> -->
        <div class="form">
            <el-form :model="form"
                     :rules="rules"
                     ref="ruleForm"
                     class="demo-ruleForm">
                <el-form-item prop="username">
                    <el-input placeholder="*姓名"
                              v-model="form.username"
                              clearable />
                </el-form-item>
                <el-form-item prop="email">
                    <el-input placeholder="*邮箱 请输入QQ邮箱"
                              v-model="form.email"
                              clearable />
                </el-form-item>
                <el-form-item prop="password">
                    <el-input placeholder="*请输入6-16位密码"
                              v-model="form.password"
                              clearable />
                </el-form-item>
                <el-form-item prop="confirmPassword">
                    <el-input placeholder="*请输入确认密码"
                              v-model="form.confirmPassword"
                              clearable />
                </el-form-item>
                <el-form-item prop="objective">
                    <el-select style="width: 100%"
                               clearable
                               v-model="form.objective"
                               placeholder="*请选择注册目的">
                        <el-option v-for="item in options"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.label">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="code">
                    <div style="display: flex; align-items: center">
                        <el-input style="width: 60%"
                                  placeholder="*请输入邮箱验证码"
                                  v-model="form.code"
                                  clearable />
                        <span @click="getCode"
                              class="getCode">{{getCodeVal}}</span>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <div class="btn">
            <div @click="register">注册</div>
            <span @click="$router.push('/login')">使用已有账户登录</span>
        </div>
    </div>
</template>

<script>
import { register, sendEmailCode } from '@/api/login'
export default {
    data () {
        var validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入密码"));
            } else if (value !== this.form.password) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        return {
            getCodeVal: '获取验证码',
            options: [
                { value: "1", label: "成为缩水师锻炼自己" },
                { value: "2", label: "让珍藏的EXCEL走向市场", },
                { value: "3", label: "投注站申请帮扶" },
                { value: "4", label: "为梦想而来" },
            ],
            form: {
                username: 'hexinle',
                email: '970611994@qq.com',
                password: '123456',
                confirmPassword: '123456',
                registerType: 'email',
				objective:'',
                code: '',
                uuid: '',
            },
            rules: {
                username: [
                    { required: true, message: "请输入姓名", trigger: "change", },
                ],
                email: [
                    { required: true, message: "请输入邮箱地址", trigger: "change", },
                    { type: "email", message: "请输入正确的邮箱地址", trigger: ["blur", "change"], },
                ],
                password: [
                    { required: true, max: 16, min: 6, message: "请输入6-16位密码", trigger: ["blur", "change"], },
                ],
                confirmPassword: [
                    { required: true, validator: validatePass2, trigger: ["blur", "change"], },
                ],
                objective: [
                    { required: true, message: '请选择注册目的', trigger: ["blur", "change"], },
                ],
                code: [
                    { required: true, message: '请输入邮箱验证码', trigger: ["blur", "change"], },
                ]
            },
        };
    },
    methods: {
        getCode () {

            if (!this.$utils.yz.isEmail(this.form.email)) {
                this.$message({ message: '请输入正确的邮箱', type: 'warning' });
                return
            }

            if (this.getCodeVal == "获取验证码") {
                this.getCodeVal = "59s"
                let num = 59
                let tirm = setInterval(_ => {
                    num--;
                    if (num <= 1) {
                        this.getCodeVal = "获取验证码"
                        clearInterval(tirm)
                    } else {
                        this.getCodeVal = num + 's'
                    }
                }, 1000)


                sendEmailCode({
                    sendTo: this.form.email
                }).then(res => {
                    console.log('发送邮箱验证码', res);
                    if (res.code == 200) {
                        this.form.uuid = res.data.uuid
                        this.$message({ message: '验证码发送成功', type: 'success' });
                    } else {
                        this.$message({ message: res.message, type: 'warning' });
                        this.getCodeVal = "获取验证码"
                        clearInterval(tirm)
                    }
                })
                return
                this.$http.post("/getCode", {
                    email: this.form.email,
                }).then((res) => {
                    if (res.status == 200) {
                        this.$message({ message: '验证码发送成功', type: 'success' });
                    } else {
                        this.$message({ message: res.message, type: 'warning' });
                        this.getCodeVal = "获取验证码"
                        clearInterval(tirm)
                    }

                });
            }
        },
        register () {

            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    // this.form.code = this.form.code.toUpperCase()
                    register(this.form).then(res => {
                        if (res.code == 200) {
                            this.$message({ message: '注册成功', type: 'success' });
                            this.$router.replace('/login')
                        } else {
                            this.$message.error(res.msg);
                        }
                    })

                    // this.$http.post("/register", this.form).then(res => {
                    //     console.log(res);
                    //     if(res.status == 200){
                    //         this.$message({ message: '注册成功', type: 'success' });
                    //         this.$router.replace('/login')
                    //     }else{
                    //         this.$message.error(res.message);
                    //     }
                    // })
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });

        },
    },
};
</script>

<style lang="scss" scoped>
.getCode {
    white-space: normal;
    flex: 1;
    background-color: #256dbc;
    color: #ffffff;
    cursor: pointer;
    user-select: none;
}
.register {
    padding: 0 70px;
    text-align: center;
    margin-top: -30px;

    .tit {
        // margin: 30px 0;
        margin-bottom: 30px;
    }
    .form {
        display: flex;
        flex-direction: column;
        > div,
        > input {
            margin-bottom: 20px;
        }
        input {
            padding-left: 30px;
            height: 50px;
        }
        > div {
            display: flex;
            align-items: center;
            input {
                flex: 1;
            }
            span {
                white-space: nowrap;
                margin: 0 30px;
            }
        }
    }
    .btn {
        display: flex;
        align-items: center;
        justify-content: space-between;
        div {
            background-color: #256dbc;
            padding: 15px 60px;
            color: #ffffff;
            cursor: pointer;
        }
        span {
            color: #256dbc;
            cursor: pointer;
        }
    }
}
</style>